import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class GlobalMessageService {

  private snackBar = inject(MatSnackBar)


  showError(message: string, duration = 5000): void {
    this.snackBar.open(message, 'Close', {
      duration,
      panelClass: ['mat-mdc-snack-bar-error'],
      // horizontalPosition: 'end',
      // verticalPosition: 'top',
    });
  }

  showSuccess(message: string, duration = 3000): void {
    this.snackBar.open(message, 'OK', {
      duration,
      panelClass: ['mat-mdc-snack-bar-success'],
      // horizontalPosition: 'end',
      // verticalPosition: 'top',
    });
  }
}
